import { post } from '../axios'

export function config_query_top_bar(map, option) {
  return post(
    `${process.env.VUE_APP_COMMONCONFIG}/commonConfig/topbar/page`,
    map,
    option
  ).then(response => response)
}

// 删除topbar
export function config_topbar_delete_post(map, option) {
  return post(
    `${process.env.VUE_APP_COMMONCONFIG}/commonConfig/topbar/delete`,
    map,
    option
  ).then(response => response)
}
